import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { authenticationFields } from '@/helpers/Authentication';
import { authenticationMethod, environment } from '@/helpers/Environment';
import EventBus from '@/helpers/EventBus';
import { isMembershipEnabled } from '@/helpers/Membership';
import { requestOTP } from '@/helpers/OTP';
import { reportFormValidity } from '@/helpers/Validation';
import FormInput2 from '@/components/forms/FormInput2.vue';
import { isValidationError } from '@/errors/ValidationError';
import { apiErrorMessageOrRethrow } from '@/errors/helpers';
import store from '@/store/store';
@Component({
    name: 'LoginFlowStepEmail',
    components: { FormInput2 },
})
export default class default_1 extends Vue {
    @Prop()
    showBecomeMemberLink;
    @Emit('goToStep')
    goToStep(nextStep) {
        return nextStep;
    }
    t;
    email = '';
    error = null;
    submitting = false;
    created() {
        this.email = store.getters['LoginFlow/email'];
    }
    get field() {
        const [email] = authenticationFields() ?? [];
        return email;
    }
    get authenticationMethod() {
        return authenticationMethod;
    }
    setLoginFlowData(loginFlowData) {
        return store.dispatch('LoginFlow/setData', loginFlowData);
    }
    async goToPassword() {
        try {
            await reportFormValidity(this.$el);
            await this.setLoginFlowData({ email: this.email, token: undefined, redirectPath: undefined });
            this.goToStep('password');
        }
        catch {
            // Ignore validation errors as they are handled in the form
        }
    }
    async goToOTP() {
        try {
            await reportFormValidity(this.$el);
            this.submitting = true;
            const token = await requestOTP({ email: this.email, state: environment.seller?.slug });
            // set data to the store, so it can be read if the magic link is opened in a new tab
            await this.setLoginFlowData({
                email: this.email,
                token,
                redirectPath: this.$route.fullPath,
            });
            this.goToStep('otp_form');
        }
        catch (error) {
            // Ignore validation errors as they are handled in the form input itself
            if (isValidationError(error))
                return;
            this.error = apiErrorMessageOrRethrow(error, ['validation_failed', 'validate_not_email']);
        }
        finally {
            this.$nextTick(() => (this.submitting = false));
        }
    }
    dismissModal() {
        EventBus.$emit('tix:modal:dismiss', 'login');
    }
    get showMembershipLink() {
        return this.showBecomeMemberLink && isMembershipEnabled(this.flags);
    }
}
